<template>
  <div
    class="ui segment animated fadeIn"
    :class="{ loading }"
    style="min-height: 150px"
  >
    <div v-if="show">
      <FullDialogBol
        v-if="show"
        :opts="opts"
        :dialog="dialog"
        v-on:close="closeDialog()"
      />
    </div>
    <div v-else>
      <div v-if="receivables.length == 0" class="grey text m-t-10">
        <i class="info circle icon"></i> Nenhum título em aberto
      </div>

      <div v-else class="ui basic segment animated fadeIn">
        <table
          class="ui blue table"
          v-for="(receivables, i) in titles"
          :key="i"
        >
          <thead class="desktop-only">
            <div class="ui large label">Titulo: {{ receivables[0].id }}</div>
            <tr>
              <th>Status</th>
              <th>Prefixo</th>
              <th>Número</th>
              <th>Parcela</th>
              <th>Emissão</th>
              <th>Vencimento</th>
              <th>Venc. Real</th>
              <th>Valor</th>
              <th>Boleto</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(receivable, i) in receivables" :key="i">
              <td>
                <strong class="mobile-only">Status: </strong>
                <span v-if="receivable.expired"
                  ><i class="exclamation circle red icon"></i> Vencido</span
                >
                <span v-else><i class="clock teal icon"></i> Em aberto</span>
              </td>
              <td>
                <strong class="mobile-only">Prefixo: </strong
                >{{ receivable.prefix }}
              </td>
              <td>
                <strong class="mobile-only">Número: </strong>{{ receivable.id }}
              </td>
              <td>
                <strong class="mobile-only">Parcela: </strong
                >{{ receivable.installment }}
              </td>
              <td>
                <strong class="mobile-only">Emissão: </strong
                >{{ $formatDate(receivable.date) }}
              </td>
              <td>
                <strong class="mobile-only">Vencimento: </strong
                >{{ $formatDate(receivable.maturityDate) }}
              </td>
              <td :class="{ 'red text': receivable.expired }">
                <strong class="mobile-only">Venc. Real: </strong>
                {{ $formatDate(receivable.realMaturity) }}
              </td>
              <td>
                <strong class="mobile-only">Valor: </strong>R$
                {{ $formatCurrency(receivable.value) }}
              </td>
              <td>
                <span v-if="receivable.expired">
                  <button @click="openDialog(receivable)" class="ui icon button">
                    <i class="barcode icon"></i>
                  </button>
                </span>
                <span v-else class="ui checkbox">
                <input type="checkbox" name="SelectTitle" :id="receivable.id" :value="receivable" v-model="SelectedTitle"/>
                <label></label>
                 <button @click="openDialog(receivable)" class="ui icon button">
                    <i class="barcode icon"></i>
                  </button>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerService from "@/services/customer-service";
import BoletoService from "@/services/boleto-service";
import FullDialogBol from "../../../components/fullDialogBol";

export default {
  components: {
    FullDialogBol,
  },
  data() {
    return {
      loading: true,
      show: false,
      dialog: false,
      opts: {},
      titles: {},
      receivables: [],
      SelectedTitle:[]
    };
  },

  props: ["customer"],

  created() {
    this.loadReceivables();
  },

  methods: {
    async getDataBoleto(titulo) {
      try {
        return await BoletoService.getBoleto({
          idcli: this.customer.recno,
          idtitulo: titulo.recno,
        });
      } catch (err) {
        console.log(`ERRO ${err.message})`);
        this.msgErro = err.message;
        return null;
      }
    },

    async getDataTitle(titulo) {
      try {
        return await BoletoService.getTitle({
          idcli: this.customer.recno,
          idtitulo: titulo.recno,
        });
      } catch (err) {
        console.log(`ERRO ${err.message})`);
        this.msgErro = err.message;
        return null;
      }
    },

    async loadReceivables() {
      this.loading = true;
      try {
        this.receivables = await CustomerService.getOpenReceivables(
          this.customer.code,
          this.customer.unit
        );
        this.receivables.forEach(this.orderTit);
      } catch (error) {
        this.$errorHandler(error);
      }
      this.loading = false;
    },

    async openDialog(titulo) {
      this.initOpts();
      const ret = await this.getDataTitle(titulo);
      if (!ret) {
        alert(
          "Titulo não enviado ao banco ou com problemas. \n" +
            "Entre em contato com o departamento financeiro"
        );
        this.closeDialog();
      } else {
        const title = ret.titulos[0].titulos[0];
        this.opts.pdfBol = await this.getDataBoleto(titulo);
        this.opts.banco = title.banco.trim();
        this.opts.CpfCedente = title.cedente.trim();
        this.opts.CpfSacado = title.sacado.trim();
        this.opts.NossoNum = title.nossoNumero.trim();
        this.opts.vencido = title.situacao === "ATRASADO" ? true : false;
        this.opts.nomeCliente = ret.cliente.trim();
        this.opts.agencia = title.agencia.trim();
        this.opts.conta = title.conta.trim();
        this.opts.email = this.customer.mailContact.trim();

        if (title) {
          this.show = true;
        }
        this.dialog = true;
      }
    },

    initOpts() {
      this.opts = {
        banco: "",
        CpfCedente: "",
        CpfSacado: "",
        NossoNum: "",
        vencido: false,
        nomeCliente: "",
        agencia: "",
        conta: "",
        email: "",
      };
    },

    closeDialog() {
      this.dialog = false;
      this.show = false;
    },

    orderTit(title) {
      if (!this.titles[title.prefix + title.id]) {
        this.titles[title.prefix + title.id] = [];
      }
      this.titles[title.prefix + title.id].push(title);
    },
  },
};
</script>
